import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';

/* ── A transfer would replace an existing file ─────────────────────────── */
/* The dialog lives in ./ftp/TransferConflictModal.js. */

/* ── Zip unavailable on the server ─────────────────────────────────────── */

/** The install commands, per package manager. Shown as text to copy — never
 *  run on the user's behalf: installing software on a server is theirs to
 *  decide, and it usually needs `sudo`, which this app must never hold. */
// The labels are distribution NAMES, not text — identical in every language —
// so they are constants here rather than locale keys a translator would have to
// copy verbatim (and the en/de anti-copy guard would rightly flag).
export const ZIP_INSTALL_COMMANDS = [
  { label: 'Debian / Ubuntu', command: 'sudo apt install zip' },
  { label: 'Fedora / RHEL / Rocky', command: 'sudo dnf install zip' },
  { label: 'Alpine', command: 'sudo apk add zip' },
];

/**
 * The server has neither `zip` nor `python3`, so Compress cannot work until
 * something is installed. Says exactly that, and what to run, instead of the
 * raw `bash: zip: command not found` the feature used to surface.
 */
export function ZipInstallModal({ onClose }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(null);
  const copy = async (command) => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(command);
    } catch {
      setCopied(null);
    }
  };
  return (
    <Modal isOpen onClose={onClose} title={t('ftp.zipUnavailableTitle')} type="warning">
      <div className="space-y-3">
        <p className="ftp-delete-question">{t('ftp.zipUnavailableBody')}</p>
        <ul className="ftp-install-list">
          {ZIP_INSTALL_COMMANDS.map((row) => (
            <li key={row.command} className="ftp-install-row">
              <span className="ftp-install-label">{row.label}</span>
              <code className="ftp-install-cmd">{row.command}</code>
              <button type="button" className="ftp-mini-btn" onClick={() => copy(row.command)}>
                {copied === row.command ? t('ftp.copied') : t('ftp.copy')}
              </button>
            </li>
          ))}
        </ul>
        <p className="ftp-modal-note">{t('ftp.zipUnavailableHint')}</p>
        <div className="modal-footer-row">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
          >
            {t('ftp.gotIt')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
